import { useRef, useEffect, useState, useCallback } from 'react';

import { Animated } from 'react-native';

const MSC_DURATION = 6000;

/**
 * Useful for preparing all the required properties for progress
 * animations
 *
 * @param params - All the parameters that necessary to prepare the animation
 */
export function useAnimatedProgress(params: Params) {
  const { duration } = params;
  const [isFinished, setFinished] = useState(false);
  const animation = useRef(new Animated.Value(0)).current;

  const handleOnComplete = useCallback(({ finished }: Animated.EndResult) => {
    setFinished(finished);
  }, []);

  useEffect(() => {
    Animated.timing(animation, {
      toValue: 1,
      duration: duration || MSC_DURATION,
      useNativeDriver: false,
    }).start(handleOnComplete);
  }, [animation, duration, handleOnComplete]);

  const width = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ['0%', '100%'],
  });

  return { width, isFinished };
}
/** Type definitions */
interface Params {
  duration?: number;
}
